import type { SaveService } from './save';

import { Environment } from '../../../environments/environment';

export async function DeleteSavedItem(
  this: SaveService,
  savedItemId: string,
  type: 'listing' | 'listing-search' = 'listing',
): Promise<boolean> {
  if (!savedItemId) {
    return false;
  }

  const _url = `${Environment.usersUrl}/saved-items/${savedItemId}`;
  const _authorization = `Bearer ${this.stateService.userToken()}`;
  const _options: RequestInit = {
    headers: {
      Authorization: _authorization,
      // eslint-disable-next-line @typescript-eslint/naming-convention -- This is the correct header name for content type.
      'Content-Type': 'application/json',
    },
    method: 'DELETE',
  };

  const _delete = await fetch(_url, _options);

  if (!_delete.ok) {
    console.error('Failed to delete saved item:', await _delete.text());

    return false;
  }

  if (type === 'listing') {
    const _removedItemId = this.filteringService
      .userSavedListingIds()
      .find((id) => id.id === savedItemId)?.itemId;

    // Update the saved listing IDs for quick lookup.
    this.filteringService.userSavedListingIds.update((ids) =>
      ids.filter((id) => id.id !== savedItemId),
    );

    // If dream homes filter is active, remove the unfavorited listing from the ids filter.
    if (this.filteringService.dreamHomes() && _removedItemId) {
      this.filteringService.ids.update((ids) => ids.filter((id) => id !== _removedItemId));
    }
  }

  if (type === 'listing-search') {
    this.filteringService.userSavedSearches.update((ids) =>
      ids.filter((search) => search.id !== savedItemId),
    );
  }

  return true;
}
